export const portfolioList = [
  {
    id: "featured",
    title: "Featured",
  },
  {
    id: "frontend",
    title: "Front-End",
  },
  {
    id: "fullstack",
    title: "Full-Stack",
  },
  {
    id: "web3",
    title: "Web 3.0",
  },
];

export const featuredPortfolio = [
  {
    id: 1,
    title: "TransferKrypt",
    img: "https://i.imgur.com/K4GroFa.png",
    repositoryUrl: "https://github.com/developer-junaid/Transfer-Krypt",
    liveUrl: "https://transferkrypt.netlify.app/",
    tagline: "Transfer Crypto / Blockchain",
  },
  {
    id: 2,
    title: "Memories Social Media App",
    img: "https://i.imgur.com/1tPbhdS.png",
    repositoryUrl: "https://github.com/developer-junaid/MERN-Memories-App",
    liveUrl: "https://memories-manager.netlify.app/",
    tagline: "Social Media / Management",
  },
  {
    id: 3,
    title: "Ecommerce Store",
    img: "https://i.imgur.com/HBKjrC6.png",
    repositoryUrl: "https://github.com/developer-junaid/Buy-It",
    liveUrl: "https://buyit-shoes.netlify.app/",
    tagline: "Ecommerce / Stripe Payments",
  },
  {
    id: 4,
    title: "React Web3 App",
    img: "https://i.imgur.com/OxClJvP.png",
    repositoryUrl: "https://github.com/developer-junaid/React-NFT-App",
    liveUrl: "https://react-nft-project.netlify.app/",
    tagline: "Web3 / NFT Listing",
  },
];

export const frontendPortfolio = [
  {
    id: 1,
    title: "Mobile First Diaries UI",
    img: "https://i.imgur.com/mL0tRfZ.png",
    repositoryUrl: "https://github.com/developer-junaid/Mobile-First-Landing",
    liveUrl: "https://mobile-first-design.netlify.app/",
    tagline: "UI / Mobile First",
  },
  {
    id: 2,
    title: "Corona Virus Tracker",
    img: "https://i.imgur.com/JX2aJe3.png",
    repositoryUrl: "https://github.com/developer-junaid/Corona-Virus-Tracker",
    liveUrl: "https://online-corona-tracker.web.app/",
    tagline: "ReactJs / API",
  },
  {
    id: 2,
    title: "Glass UI",
    img: "https://i.imgur.com/xzcGWI6.png",
    repositoryUrl: "https://github.com/developer-junaid/Glass-Website-CSS",
    liveUrl: "https://glass-ui-website.netlify.app/",
    tagline: "UI / Glass Effect",
  },
  {
    id: 4,
    title: "Uber Eats UI",
    img: "https://i.imgur.com/VVnLdLf.png",
    repositoryUrl: "https://github.com/developer-junaid/Uber-Eats-Clone",
    liveUrl: "https://uber-eats-landing-page.netlify.app/",
    tagline: "UI / Food App",
  },
];

export const fullstackPortfolio = [
  {
    id: 1,
    title: "Blog Website",
    img: "https://i.imgur.com/gT565YO.png",
    repositoryUrl: "https://github.com/developer-junaid/Blog-Site/",
    liveUrl: "https://techberg-blog.netlify.app/",
    tagline: "Blog / Marketing",
  },
  {
    id: 2,
    title: "Nike Store",
    img: "https://i.imgur.com/td6QZtC.png",
    repositoryUrl: "https://github.com/developer-junaid/Nike-Shoe-Store",
    liveUrl: "https://nike-shoe-store.netlify.app/",
    tagline: "Ecommerce / Store",
  },
  {
    id: 3,
    title: "Ecommerce Store",
    img: "https://i.imgur.com/HBKjrC6.png",
    repositoryUrl: "https://github.com/developer-junaid/Buy-It",
    liveUrl: "https://buyit-shoes.netlify.app/",
    tagline: "Ecommerce / Stripe Payments",
  },
  {
    id: 4,
    title: "Diaries Manager",
    img: "https://i.imgur.com/5dj36pO.png",
    repositoryUrl: "https://github.com/developer-junaid/Diaries-Manager-App",
    liveUrl: "https://diaries-manager.web.app/",
    tagline: "Productivity / Management",
  },
  {
    id: 5,
    title: "Memories Social Media App",
    img: "https://i.imgur.com/1tPbhdS.png",
    repositoryUrl: "https://github.com/developer-junaid/MERN-Memories-App",
    liveUrl: "https://memories-manager.netlify.app/",
    tagline: "Social Media / Management",
  },
  {
    id: 6,
    title: "Todo List",
    img: "https://i.imgur.com/LdjTLgO.png",
    repositoryUrl: "https://github.com/developer-junaid/Jamstack-Todolist",
    liveUrl: "https://todo-list-serverless.netlify.app/",
    tagline: "Todo List / Management",
  },
];

export const web3Portfolio = [
  {
    id: 1,
    title: "React Web3 App",
    img: "https://i.imgur.com/OxClJvP.png",
    repositoryUrl: "https://github.com/developer-junaid/React-NFT-App",
    liveUrl: "https://react-nft-project.netlify.app/",
    tagline: "Web3 / NFT Listing",
  },
  {
    id: 2,
    title: "TransferKrypt",
    img: "https://i.imgur.com/K4GroFa.png",
    repositoryUrl: "https://github.com/developer-junaid/Transfer-Krypt",
    liveUrl: "https://transferkrypt.netlify.app/",
    tagline: "Transfer Crypto / Blockchain",
  },
];

// Testimonials
export const fiverrTestimonials = [
  {
    id: 1,
    text: "Great communication skills, very good english and easy to work with! thanks for the excellent work and I hope we will work together in the future again!",
    country: "Italy",
    name: "Leo Matter",
    url: "https://www.fiverr.com/developerjunaid/",
  },
  {
    id: 2,
    text: "Junaid represents among the highest levels of customer service I have experienced. Information was accurate, responses to queries were turned around very fast. Answers were clear and where necessary detailed enough for us to make informed decisions quickly. Thanks so much we will be working with you in future.",
    country: "Pakistan",
    name: "Arslan",
    url: "https://www.fiverr.com/developerjunaid/",
  },
  {
    id: 3,
    text: "Very professional and know what he is doing, will be working with you again in the future!",
    country: "Belgium",
    name: "Walid",
    url: "https://www.fiverr.com/developerjunaid/",
  },
  {
    id: 4,
    text: "this developer is the one of a kind with great communication skills!",
    country: "Denmark",
    name: "dgaa1991",
    url: "https://www.fiverr.com/developerjunaid/",
  },
  {
    id: 5,
    text: "Perfect man for your job",
    country: "Cyprus",
    name: "worldwidefame",
    url: "https://www.fiverr.com/developerjunaid/",
  },
  {
    id: 6,
    text: "From my very first message to last, the seller communicated everything clearly and asked all the right questions unlike others asking for budget. The code is very clean (easy to maintain and good commenting). Very quick delivery, ill be ordering again soon. Thanks again!!",
    country: "UK",
    name: "Ahmed",
    url: "https://www.fiverr.com/developerjunaid/",
  },
  {
    id: 7,
    text: "2nd order done already, one of the quickest delivery on Fiverr. Again, task was done alot better than expected, thank you!",
    country: "UK",
    name: "Ahmed",
    url: "https://www.fiverr.com/developerjunaid/",
  },
  {
    id: 8,
    text: "Great service, fast and responsive!",
    country: "Belgium",
    name: "Walid",
    url: "https://www.fiverr.com/developerjunaid/",
  },
  {
    id: 9,
    text: "good work, thank you",
    country: "Belgium",
    name: "Walid",
    url: "https://www.fiverr.com/developerjunaid/",
  },
];
